export const CategoriasEnum = {
  SEBRAETEC: 'SEBRAETEC',
  CONSULTORIA: 'CONSULTORIA',
  SOLUCOES_DIGITAIS: 'SOLUCOES_DIGITAIS',
  CURSO_ONLINE: 'CURSO_ONLINE',
  EVENTOS: 'EVENTOS'
};
